export default {
    username: '',
    password: ''
}